import { useState } from "react";
import { useAddVideoMutation } from "../../../features/videos/videosApi";

export default function AddVideo() {
  const [addVideo, { isLoading, isSuccess, isError }] = useAddVideoMutation();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [url, setUrl] = useState("");
  const [duration, setDuration] = useState("");
  const [views, setViews] = useState("");

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setUrl("");
    setDuration("");
    setViews("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const createdAt = new Date().toISOString();
    addVideo({
      title,
      description,
      url,
      createdAt,
      duration,
      views,
    });
    resetForm();
  };

  return (
    <form className="video-form" onSubmit={handleSubmit}>
      <div className="space-y-2">
        <label>Video Title</label>
        <input
          required
          className="text-input"
          type="text"
          name="title"
          value={title}
          placeholder="Enter Video Title"
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <label>Video Url</label>
        <input
          required
          className="text-input"
          type="text"
          name="url"
          placeholder="Enter Video Link"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <label>Views</label>
        <input
          required
          className="text-input"
          type="text"
          name="views"
          placeholder="Enter Video Views"
          value={views}
          onChange={(e) => setViews(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <label>Duration</label>
        <input
          required
          className="text-input"
          type="text"
          name="duration"
          placeholder="Enter Video Duration"
          value={duration}
          onChange={(e) => setDuration(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <label>Description</label>
        <textarea
          required
          className="text-input"
          type="text"
          name="duration"
          placeholder="Brief description for your video"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <button
        disabled={isLoading}
        type="submit"
        className="submit"
        id="lws-submit"
      >
        Add Video
      </button>
      <div>
        {isSuccess && (
          <p className="text-center" style={{ color: "green" }}>
            Video add successfully
          </p>
        )}
        {isError && (
          <p className="text-center" style={{ color: "red" }}>
            There was an error
          </p>
        )}
      </div>
    </form>
  );
}
